import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IDropModal } from "types/other/TypeOthers";
import LogOutModal from "utils/other/LogOutModal";
import Drawer from "react-modern-drawer";
import { appVersion } from "services/config/url";
import { useBrandsConfig } from "utils/v2/BrandsConfig/BrandsConfigContext";
import { useChatIndexQuery } from "redux/RTQ/IlenkradApi";
import { toPersianNumbers } from "common/common";
const Menubar: FC<IDropModal> = ({ open, onClose, showOverLay }) => {
  const { logo, title } = useBrandsConfig();
  const navigate = useNavigate();
  const { data: dataChat } = useChatIndexQuery();
  const [openModalLogout, setOpenModalLogout] = useState<boolean>(false);
  if (!showOverLay) return null;

  type MenuItem = {
    name: string;
    key: number;
    Icon: string;
    url: string;
    isChatAction?: boolean;
  };

  const itemMenuBar: MenuItem[] = [
    { name: "گزارشات", key: 1, Icon: "icon-report", url: "/reports" },
    {
      name: "محدوده جغرافیایی",
      key: 2,
      Icon: "icon-GeographicArea",
      url: "/limitations",
    },
    {
      name: "تمدید سامانه",
      key: 3,
      Icon: "icon-paymentActive",
      url: "/transactions",
    },
    {
      name: "سرویس های دوره ای",
      key: 4,
      Icon: "icon-servicesActive",
      url: "/services",
    },
    {
      name: "چت با پشتیبانی",
      key: 5,
      Icon: "icon-message",
      url: "support-chat",
      isChatAction: true,
    },
    { name: "تنظیمات", key: 6, Icon: "icon-settings", url: "/settings" },
    { name: "خروج", key: 7, Icon: "icon-logout", url: "logout" },
  ];

  const showModalLogout = () => {
    setOpenModalLogout(!openModalLogout);
  };
  const navigateToPage = (url: string, isChatAction?: boolean) => {
    if (url === "logout") {
      showModalLogout();
      onClose();
      return;
    }
    if (isChatAction) {
      // Find and navigate to support chat
      const supportChat = dataChat?.chats?.find(
        (chat: any) => chat?.title === "پشتیبانی",
      );
      if (supportChat) {
        navigate(`/notification/chat/${supportChat.id}`);
      }
      onClose();
      return;
    }
    navigate(`${url}`);
    onClose();
  };

  return (
    <>
      <LogOutModal open={openModalLogout} onClose={showModalLogout} />
      <Drawer
        size={210}
        zIndex={99999}
        open={open}
        onClose={onClose}
        direction="right"
      >
        <div className="drawerContainer">
          <div className="appVersion"> نسخه {toPersianNumbers(appVersion ?? '')}</div>
          <div
            className={
              title === "WEGA" ? "rowLogoMenuBarWega" : "rowLogoMenuBar"
            }
          >
            <img
              alt="logoImg"
              className={
                title === "WEGA" ? "logoImgMenubarWega" : "logoImgMenubar"
              }
              src={logo}
            />
          </div>
          <div className="colLogoMenuBarItem">
            {itemMenuBar.map((item) => (
              <div
                className="rowItemMenuBar"
                onClick={() => navigateToPage(item.url, item.isChatAction)}
                key={item.key}
              >
                <div className={`${item.Icon}`} />
                <div className="titleItemMenubar">{item.name}</div>
              </div>
            ))}
          </div>
        </div>
      </Drawer>
    </>
  );
};
export default Menubar;
